<template>
<transition name="fade">
  <div id="lightbox-content" v-if="!!showLightbox">
    <button @click="closeLightbox()">
      <i class="material-icons close-lightbox">close</i>
    </button>
    <div class="img-content">
      <div :class="{loader: loading}" class="loaded"><v-icon>mdi-loading mdi-spin</v-icon></div>
      <div class="name-container"><span class="name-text">{{showReport.labelName}}</span></div>
      <img class="single-img" :src="showReport.imgSrc" @load="loading = false" alt="">
    </div>
  </div>
</transition>
</template>

<script>
export default {
  props: {
    showReport: Object || null
  },
  watch: {
    showReport: {
      handler(report) {
        if (report !== null && !!report.imgSrc) {
          this.showLightbox = true;
          this.loading = true;
        }
        else this.showLightbox = false;
      },
      deep: true
    }
  },
  data() {
    return {
      showLightbox: false,
      loading: true
    }
  },
  methods: {
    closeLightbox() {
      this.showLightbox = false;
      this.$emit('closed')
    }
  }
}
</script>

<style lang="sass" scoped>
$text-color: #dfdfdf
$bg-color: #4a4a4a
.fade-enter-active, .fade-leave-active 
  transition: opacity .3s
#lightbox-content
  position: fixed
  display: flex
  top: 0
  bottom: 0
  right: 0
  background-color: black
  z-index: 5
  width: calc(100% - 238px)
  @media screen and (max-width: 1264px) // plus petit que 1264, width: 100%
    width: 100%
  .close-lightbox
    position: absolute
    top: 100px
    left: 50px
    font-size: 3rem
    z-index: 15
  .img-content
    position: relative
    width: 100%
    text-align: center
    margin-top: 40px
    align-self: center
    .single-img 
      max-width: 70vw
      max-height: 70vh

    .loaded
      transition: all .5s ease
      opacity: 0
      background-color: black
      position: absolute
      z-index: 10
      width: 100%
      height: 100%
      display: flex
      justify-content: center
      align-items: center
      i 
        font-size: 4rem
    .loader
      opacity: 1



  // NAME !
  .name-container
    text-align: center
    margin: 2rem 0
    .name-text
      width: 100%
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
      // word-break: break-all
      color: $text-color
      font-size: 1.3rem
      background-color: $bg-color
      padding: .2rem .8rem
      text-transform: uppercase
      cursor: default
      transition: color .3s ease-out

</style>
